

import { createPath, Link } from 'react-router-dom';
import ModalHeader from '../components/ModalHeader';




import { BsArrowLeftShort } from "react-icons/bs";

import StatBox from '../components/StatBox';

import { useQuery } from 'react-query';
import { getAllData } from '../api';
import { Autocomplete, CircularProgress, debounce, TextField } from '@mui/material';

import dayjs from 'dayjs';
import { useEffect, useMemo, useRef, useState } from 'react';

import DateRangePicker from '@wojtekmaj/react-daterange-picker/dist/DateRangePicker';

import { GoogleMap, InfoWindowF, MarkerF, useJsApiLoader } from '@react-google-maps/api';

import useAuth from '../hooks/useAuth';

import * as htmlToImage from "html-to-image";




function ProgressInfo() {

    const createFileName = (extension = "", ...names) => {
        if (!extension) {
            return "";
        }
        return `${names.join("")}.${extension}`;
    };

    const downloadFile = (image, { name = "details_screenshot", extension = "jpg" } = {}) => {
        const a = document.createElement("a");
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    //... inside of your component
    const screenshotArea = useRef(null);


    const handleMemeDownload = async () => {
        if (!screenshotArea.current) return;
        await htmlToImage.toJpeg(screenshotArea.current).then(downloadFile);

    };


    const { isAuthenticated, logout } = useAuth();

    const center = {
        lat: 37.832472,
        lng: 23.775296
    };

    const containerStyle = {
        width: '100%',
        height: '600px'
    };

    const options = {
        minZoom: 12,
        maxZoom: 17,
    }


    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        // googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        googleMapsApiKey: 'AIzaSyCjFm4pakAOkzi-x46mkQ1gkr-WSvlNfGk',
        region: "GR",
        language: "el",

    })

    function getIcon() {

        let url = 'bussines.png';
        let icon = {
            url: url,
            // scaledSize: new window.google.maps.Size(50, 50),
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(0, 0),
        }
        return icon;


    }

    const [map, setMap] = useState(null)
    const [zoom, setZoom] = useState(13)

    const [activeMarker, setActiveMarker] = useState(null)


    const [inputValueAAPAroxis, setInputValueAAPAroxis] = useState('');
    const [inputValueEponimia, setInputValueEponimia] = useState('');






    const [activeBussines, setActiveBussines] = useState(null)



    const handleSelectChangeAAPAroxis = (e, value) => {
        if (value) {
            setActiveBussines(value);
            setActiveMarker(data.rows.findIndex(business => business.AAPAROXIS === value.AAPAROXIS));
            //scroll down to the bussines after waiting for the map to render
            setTimeout(() => {
                document.getElementById('bussines').scrollIntoView({ behavior: "smooth" });
            }, 100)
        }
    };

    const handleSelectChangeEponimia = (e, value) => {
        if (value) {
            setActiveBussines(value);
            setActiveMarker(data.rows.findIndex(business => (business.EPONIMIA === value.EPONIMIA && business.AAPAROXIS === value.AAPAROXIS)));
            //scroll down to the bussines after waiting for the map to render
            setTimeout(() => {
                document.getElementById('bussines').scrollIntoView({ behavior: "smooth" });
            }, 100)
        }
    };





    const [date, setDate] = useState(dayjs());

    //this must select the current month. If we are in the first 10 days it must select from 1 to 10 of the current month
    // const [value, onChange] = useState([dayjs().startOf('month').toDate(), dayjs().toDate()]);

    //select the last 30 days - mut for the first date use 00:00:00 and for the second 23:59:59
    const [value, onChange] = useState([dayjs().subtract(30, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()]);
    const { isLoading, isError, data, isFetching } =
        useQuery(['live_data', date, value], () => getAllData({ page: 0, limit: null, date: date, dates: value }), {
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: false,
            onSuccess: (data) => {

            }

        })


    // a function to get the sum of the collections
    //like all SumCollections, SumCollections_Symmeikta, SumKg, SumKg_Symmeikta for all the bussines
    const getSum_all = useMemo(() => {
        if (!data) return null;
        let SumKg = 0;
        let SumKg_Symmeikta = 0;
        let SumCollections = 0;
        let SumCollections_Symmeikta = 0;
        let SumCost = 0;
        let SumCost_Symmeikta = 0;
        let NewDT = 0;
        let YfistamenaDT = 0;
        let Anadromiki = 0;

        //we need the average value of the metamoli
        //it is a "-23%" for example
        let Metavoli_arr = [];

        // log data.rows length
        console.log("LLLLL: ", data.rows.length);

        data.rows.forEach((bussines, i) => {
            SumKg += parseFloat(bussines.SumKg);
            SumKg_Symmeikta += parseFloat(bussines.SumKg_Symmeikta);
            SumCollections += parseFloat(bussines.SumCollections);
            SumCollections_Symmeikta += bussines.SumCollections_Symmeikta;
            SumCost += parseFloat(bussines.SumCost);
            SumCost_Symmeikta += parseFloat(bussines.SumCost_Symmeikta);
            NewDT += parseFloat(bussines.NewDT);
            console.log(i);
            YfistamenaDT += parseFloat(bussines.YfistamenaDT);
            Anadromiki += parseFloat(bussines.Anadromiki);
            Metavoli_arr.push(parseFloat(bussines.Metavoli));
        });

        return {
            SumKg: SumKg,
            SumKg_Symmeikta: SumKg_Symmeikta,
            SumCollections: SumCollections,
            SumCollections_Symmeikta: SumCollections_Symmeikta,
            SumCost: SumCost,
            SumCost_Symmeikta: SumCost_Symmeikta,
            NewDT: parseFloat(NewDT).toFixed(2),
            YfistamenaDT: parseFloat(YfistamenaDT).toFixed(2),
            Anadromiki: parseFloat(Anadromiki).toFixed(2),
            Metavoli: (Metavoli_arr.reduce((a, b) => a + b, 0) / Metavoli_arr.length).toFixed(2)
        };
    }, [data]);



    //actual render

    if (isLoading || !isLoaded)
        return <div
            className='flex justify-center items-center h-screen'><CircularProgress></CircularProgress></div>

    if (isError)

        return <div
            className='flex p-8 justify-center h-screen items-center'>
            <div className=' text-center'>

                <p className='texgt-md font-medium'>ERROR LOADING DATA: { } </p>
            </div>
        </div>

    if (data.length < 1)
        return <div className='flex p-8 justify-center h-screen items-center'>
            <div className=' text-center'>
                <p className='texgt-md font-medium'>No Data To Load</p>
            </div>
        </div>



    // setActiveBussines(data.rows[0])


    return (
        <div className="flex flex-col justify-between bg-white">


            <ModalHeader title="Διαλογή στην Πηγή" subtitle="Progress Stats"></ModalHeader>




            <div className='items-center justify-between mx-auto mb-2 -mt-2 lg:flex lg:px-0'>

                <Link to={"/select"} className="flex text-app_green_light shadow-md  font-bold rounded-full text-lg px-10 py-2 text-center">
                    <BsArrowLeftShort className='self-center w-6 h-6 text-app_green_light' /> Επιστροφή
                </Link>

                <div
                    onClick={() => {
                        logout()
                    }}
                    className="cursor-pointer ml-3 flex text-gray-400 shadow-md  font-bold rounded-full text-lg px-10 py-2 text-center">
                    Αποσύνδεση
                </div>
            </div>



            <div className="2xl:w-[1600px] w-full px-10 py-2 mt-5 mx-auto sm:py-2 sm:px-6  lg:px-2">
                <div className="flex  justify-center items-center pb-1">
                    <div className="pr-2 text-md font-semibold">Περίοδος: </div>

                    <DateRangePicker
                        className="!rounded-3xl !border-2 border-[#E0E0E0] shadow-sm "
                        onChange={(dates) => {
                        

                            //if diference is more than 6 months (183 days) show alert
                            if (dayjs(dates[1]).diff(dayjs(dates[0]), 'days') > 183) {
                                alert('Μπορείτε να επιλέξετε μέγιστο εύρος 6 μηνών')
                                return
                            }


                            //we need to set hour to 00:00:00 for the start date and 23:59:59 for the end date

                            var start = new Date(dates[0]);
                            start.setHours(0, 0, 0, 0);

                            var end = new Date(dates[1]);
                            end.setHours(23, 59, 59, 999);


                            onChange([start, end])
                            setActiveMarker(null)
                            setActiveBussines(null)
                        }}
                        value={value}
                        locale='el-GR'
                        clearIcon={null}
                        // minDetail='month'
                        maxDate={dayjs().toDate()}

                    />
                </div>









                <div className="flex justify-center items-center mt-3">

                    {/* Αναζήτηση με Α.ΠΑΡΟΧΗΣ */}
                    <Autocomplete
                        className="w-full max-w-md mr-2"
                        options={data.rows}
                        getOptionLabel={(option) => option.AAPAROXIS || ""}
                        inputValue={inputValueAAPAroxis}
                        onInputChange={(event, newInputValue) => setInputValueAAPAroxis(newInputValue)}
                        onChange={handleSelectChangeAAPAroxis}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Αναζήτηση με Α.ΠΑΡΟΧΗΣ"
                            />
                        )}
                    />

                    {/* Αναζήτηση με Όνομα */}
                    <Autocomplete
                        className="w-full max-w-md ml-2"
                        options={data.rows}
                        getOptionLabel={(option) => option.EPONIMIA || ""}
                        inputValue={inputValueEponimia}
                        onInputChange={(_, newInputValue) => setInputValueEponimia(newInputValue)}
                        onChange={handleSelectChangeEponimia}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Αναζήτηση με Όνομα"
                            />
                        )}


                        renderOption={(props, item) => (
                            <li {...props} key={item.key}>
                                {item.EPONIMIA}
                            </li>
                        )}
                    />
                </div>


                <div className="flex mt-3 mb-10 rounded-3xl shadow-lg  overflow-hidden  w-full bg-red-300">
                    <GoogleMap

                        mapContainerStyle={containerStyle}
                        center={center}
                        zoom={zoom}
                        options={options}  // onLoad={onLoad}
                    // onUnmount={onUnmount}
                    >

                        { /* Child components, such as markers, info windows, etc. */}
                        {
                            data.rows.map((place, index) => {
                                try {
                                    let pos = { lat: place.Latitude, lng: place.Longtitude }
                                    // console.log(pos)
                                    return <MarkerF
                                        key={index}
                                        onClick={() => {
                                            setActiveMarker(index)
                                            setActiveBussines(place)
                                            //scroll down to the bussines after waiting for the map to render
                                            setTimeout(() => {
                                                document.getElementById('bussines').scrollIntoView({ behavior: "smooth" });
                                            }, 100)

                                        }}
                                        icon={getIcon()}
                                        position={pos}

                                    >
                                        {activeMarker === index ? <InfoWindowF
                                            // options={{ pixelOffset: new window.google.maps.Size(0, -10) }}
                                            onCloseClick={() => { }}>
                                            <div className='flex flex-col justify-center items-center space-y-3 p-2'>
                                                <div className='font-semibold'>{place.EPONIMIA ?? '-'}</div>
                                                {/* <div>{getMerchantCategory(place.MerchantId)}</div> */}
                                                <div>{place.ROAD ?? '-'}</div>
                                            </div>
                                        </InfoWindowF> : null}
                                    </MarkerF>
                                } catch (error) {
                                    return null;
                                }
                            })
                        }

                    </GoogleMap>
                </div>


                <div className='pb-3 my-3 shadow-lg bg-gradient-to-r from-app_green to-app_blue rounded-3xl' >

                    <div className='h-full p-5 bg-white rounded-3xl -mt-0.5' >
                        {/* <div className=" text-xl font-bold text-app_blue mt-3">Συνολικά Στοιχεία Δήμου:</div> */}
                        <h2 className="text-2xl font-bold text-app_yellow mt-3">Συνολικά Στοιχεία Δήμου:</h2>

                        <div className='flex flex-wrap gap-0 mt-3'>
                            <StatBox title="ΣΥΝ. ΑΠΟΚΟΜΙΔΕΣ ΟΡΓΑΝΙΚΩΝ" number={getSum_all.SumCollections} version={0}></StatBox>
                            <StatBox title="ΣΥΝ. ΚΙΛΑ ΟΡΓΑΝΙΚΩΝ" number={getSum_all.SumKg} version={0}></StatBox>
                            <StatBox title="ΣΥΝ. ΑΠΟΚΟΜΙΔΕΣ ΣΥΜΜΕΙΚΤΩΝ" number={getSum_all.SumCollections_Symmeikta} version={0}></StatBox>
                            <StatBox title="ΣΥΝ. ΚΙΛΑ ΣΥΜΜΕΙΚΤΩΝ" number={getSum_all.SumKg_Symmeikta} version={0}></StatBox>
                        </div>

                        <div className='flex flex-wrap gap-0 mt-3'>
                            <StatBox title="ΚΟΣΤΟΣ ΟΡΓΑΝΙΚΩΝ(€)" number={getSum_all.SumCost} version={0}></StatBox>
                            <StatBox title="ΚΟΣΤΟΣ ΣΥΜΜΕΙΚΤΩΝ(€)" number={getSum_all.SumCost_Symmeikta.toFixed(2)} version={0}></StatBox>
                            <StatBox title="ΝΕΑ ΔΤ(€)" number={getSum_all.NewDT} version={0}></StatBox>
                            <StatBox title="ΥΦΙΣΤΑΜΕΝΑ ΔΤ(€)" number={getSum_all.YfistamenaDT} version={0}></StatBox>
                            <StatBox title="ΠΟΣΟ ΑΝΑΔΡΟΜΙΚΗΣ ΧΡΕΩΣΗΣ ΔΤ(€)" number={getSum_all.Anadromiki} version={0}></StatBox>
                            <StatBox title="M.O ΜΕΤΑΒΟΛΗΣ ΔΤ (%)" number={getSum_all.Metavoli} version={0}></StatBox>


                        </div>

                    </div>

                </div>


                <div className="grid grid-cols-1 xl:grid-cols-1 gap-8  p-2" id='bussines' ref={screenshotArea}>

                    {
                        activeBussines ?
                            <div className='pb-3 shadow-lg bg-gradient-to-r from-app_green to-app_blue rounded-3xl' >

                                <div className='h-full p-5 bg-white rounded-3xl -mt-0.5' >
                                    <div className='flex'>
                                        {/* <BusinessTwoTone className='!w-30 !h-30 text-app_yellow' height={'125px'}/> */}
                                        {/* <img src="bussines.svg" className='' height={'55px'} width={'55px'} alt="" /> */}
                                        <h2 className="text-2xl font-bold text-app_yellow mt-3">{activeBussines.EPONIMIA} - {activeBussines.ROAD + " " + activeBussines.ROADNO}</h2>
                                    </div>
                                    {/* a div to show the selected date range */}
                                    <div className=" text-md font-bold text-app_blue mt-1">Περίοδος: {dayjs(value[0]).format('DD/MM/YYYY')} - {dayjs(value[1]).format('DD/MM/YYYY')}</div>
                                    <div className=" text-xl font-bold text-app_blue mt-3">Στοιχεία Επιχείρησης:</div>
                                    <div className='flex flex-wrap gap-0 mt-3'>
                                        <StatBox title="ΠΟΛΗ" number={activeBussines.CITY} version={2}></StatBox>
                                        <StatBox title="ΚΑΤΗΓΟΡΙΑ" number={activeBussines.BUSINESS_TYPE} version={2}></StatBox>
                                        <StatBox title="Α.ΠΑΡΟΧΗΣ" number={activeBussines.AAPAROXIS} version={1}></StatBox>
                                        {/* <StatBox title="ΔΙΕΥΘΥΝΣΗ" number={activeBussines.ROAD + " " + activeBussines.ROADNO} version={1}></StatBox> */}
                                        {/* <StatBox title="TAG ΟΡΓΑΝΙΚΩΝ" number={activeBussines.TAGNO} version={1}></StatBox> */}
                                        <StatBox title="BINNo  ΚΑΦΕ ΚΑΔΟΥ" number={activeBussines.COVERNO} version={1}></StatBox>
                                        {/* <StatBox title="TAG ΣΥΜΜΕΙΚΤΩΝ" number={activeBussines.TAGNO_Symmeikta ?? '...'} version={1}></StatBox> */}
                                        <StatBox title="BINNo ΠΡΑΣΙΝΟΥ ΚΑΔΟΥ" number={activeBussines.COVERNO_Symmeikta ?? "..."} version={1}></StatBox>

                                        <StatBox title="ΤΜ.ΔΤ" number={activeBussines.TetrMetraDT ?? "..."} version={1}></StatBox>
                                        <StatBox title="ΣΥΝΤΕΛΕΣΤΗΣ ΔΤ(€/T.M.)" number={activeBussines.Syntelestis} version={1}></StatBox>

                                    </div>



                                    <div className=" text-xl font-bold text-app_blue mt-3">Στοιχεία αποκομιδής απορριμμάτων:</div>
                                    <div className='flex flex-wrap gap-0 mt-3'>

                                        <StatBox title="ΣΥΝ. ΑΠΟΚΟΜΙΔΕΣ ΟΡΓΑΝΙΚΩΝ" number={activeBussines.SumCollections} version={0}></StatBox>
                                        <StatBox title="ΣΥΝ. ΚΙΛΑ ΟΡΓΑΝΙΚΩΝ" number={activeBussines.SumKg} version={0}></StatBox>
                                        <StatBox title="ΣΥΝ. ΑΠΟΚΟΜΙΔΕΣ ΣΥΜΜΕΙΚΤΩΝ" number={activeBussines.SumCollections_Symmeikta} version={0}></StatBox>
                                        <StatBox title="ΣΥΝ. ΚΙΛΑ ΣΥΜΜΕΙΚΤΩΝ" number={activeBussines.SumKg_Symmeikta} version={0}></StatBox>



                                    </div>

                                    <div className=" text-xl font-bold text-app_blue mt-3">Δημοτικά Τέλη:</div>
                                    <div className='flex flex-wrap gap-0 mt-3'>



                                        <StatBox title="ΚΟΣΤΟΣ ΟΡΓΑΝΙΚΩΝ(€)" number={activeBussines.SumCost} version={0}></StatBox>
                                        <StatBox title="ΚΟΣΤΟΣ ΣΥΜΜΕΙΚΤΩΝ(€)" number={activeBussines.SumCost_Symmeikta} version={0}></StatBox>
                                        <StatBox title="ΝΕΑ ΔΤ(€)" number={activeBussines.NewDT} version={0}></StatBox>
                                        <StatBox title="ΥΦΙΣΤΑΜΕΝΑ ΔΤ(€)" number={activeBussines.YfistamenaDT} version={0}></StatBox>
                                        <StatBox title="ΠΟΣΟ ΑΝΑΔΡΟΜΙΚΗΣ ΧΡΕΩΣΗΣ ΔΤ(€)" number={activeBussines.Anadromiki} version={0}></StatBox>
                                        <StatBox title="ΜΕΤΑΒΟΛΗ ΔΤ (%)" number={activeBussines.Metavoli} version={0}></StatBox>

                                    </div>


                                    {/* a line to seperate the bussines and the total */}
                                    {/* <div className="border-b-2 border-app_blue mt-5"></div>

                                    <div className=" text-xl font-bold text-app_blue mt-3">Συνολικά Στοιχεία Δήμου:</div>

                                    <div className='flex flex-wrap gap-0 mt-3'>


                                        <StatBox title="ΣΥΝ. ΑΠΟΚΟΜΙΔΕΣ ΟΡΓΑΝΙΚΩΝ" number={getSum_all().SumCollections} version={0}></StatBox>
                                        <StatBox title="ΣΥΝ. ΚΙΛΑ ΟΡΓΑΝΙΚΩΝ" number={getSum_all().SumKg} version={0}></StatBox>
                                        <StatBox title="ΣΥΝ. ΑΠΟΚΟΜΙΔΕΣ ΣΥΜΜΕΙΚΤΩΝ" number={getSum_all().SumCollections_Symmeikta} version={0}></StatBox>
                                        <StatBox title="ΣΥΝ. ΚΙΛΑ ΣΥΜΜΕΙΚΤΩΝ" number={getSum_all().SumKg_Symmeikta} version={0}></StatBox>



                                    </div> */}





                                </div>





                            </div>
                            : null
                    }



                </div>


                {/* capture screenshot button */}
                {
                    activeBussines ? <div className="flex mt-8 mb-28">

                        <button onClick={handleMemeDownload} className="bg-app_green text-white font-semibold rounded-full px-5 py-2">Καταγραφή Στιγμιότυπου/Screenshot

                        </button>


                    </div>
                        : null
                }


            </div>






        </div>
    );
}

export default ProgressInfo;
